var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.4L25.6 4 16 13.6 6.4 4 4 6.4l9.6 9.6L4 25.6 6.4 28l9.6-9.6 9.6 9.6 2.4-2.4-9.6-9.6L28 6.4z",
    fill: "#232020"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0yOCA2LjRMMjUuNiA0TDE2IDEzLjZMNi40IDRMNCA2LjRMMTMuNiAxNkw0IDI1LjZMNi40IDI4TDE2IDE4LjRMMjUuNiAyOEwyOCAyNS42TDE4LjQgMTZMMjggNi40WiIgZmlsbD0iIzIzMjAyMCIvPgo8L3N2Zz4K";
export { SvgCloseMenuIcon as ReactComponent };